import axios from '@app/config/axios.config';

type GetMandatsParams = {
    page: number;
    limit: number;
    search: string;
    sort_by: string;
    asc: boolean;
    clubId: string | false;
};

export type Mandat = {
    id: number;
    createdAt: string;
    updatedAt: string;
    club: { id: number; nom: string };
    pdfPath: string;
    ref: string;
    dateAccord: string;
    notes: string;
    dateDebutAquisition: string;
    dateFinAcquisition: string;
    budget: number;
    devise: string;
    acvf: boolean;
    dateArretDemande: string;
    dateCloture: string;
    gestionDeLogo: number;
    fraisDeServiceAquisitionMateriel: number;
    fraisDeServiceRistourne: number;
    parrainage: { id: number };
    commandeMateriel: { id: number };
    langue: string;
    listePublicites: string;
};

export const getMandats = async (
    params: GetMandatsParams
): Promise<{ mandats: Mandat[]; totalCount: number }> => {
    try {
        const res = await axios.get('/mandats', { params });
        return res.data;
    } catch (err) {
        console.error(err);
        return { mandats: [], totalCount: 0 };
    }
};

export const getMandatById = async (id: string) => {
    return await axios.get(`/mandats/${id}`);
};

export type CreateMandatsBody = {
    nom: string;
    sport: string;
    adresse: string;
};

export const createMandat = async (
    body: CreateMandatsBody
): Promise<{ mandats: Mandat }> => {
    return await axios.post('/mandats', body);
};

export const uploadMandatPdf = async (id: number, file: File) => {
    const formData = new FormData();
    formData.append('file', file);

    return await axios.post(`/mandats/${id}/upload-pdf`, formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

export const getMandatPdfUrl = async (id: number) => {
    return await axios.get(`/mandats/${id}/pdf-url`);
};

export const updateMandat = async (id: number, data: Partial<Mandat>) => {
    return await axios.patch(`/mandats/${id}`, data);
};
